import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './RosreestrLabel.css';

export const RosreestrLabel = () => (
  <div className={styles['rosreestr-label']}>
    <UIText3>Проверено в Росреестре</UIText3>
  </div>
);
